import React from 'react';
import styles from './StateAvailablePanel.module.css';

const stateZipCodes = {
    'Alabama': '36104',
    'Arizona': '85001',
    'Arkansas': '72201',
    'California': '95814',
    'Colorado': '80202',
    'Connecticut': '06103',
    'Delaware': '19901',
    'Florida': '32301',
    'Georgia': '30303',
    'Hawaii': '96813',
    'Idaho': '83702',
    'Illinois': '62701',
    'Indiana': '46204',
    'Iowa': '50309',
    'Kansas': '66603',
    'Kentucky': '40601',
    'Louisiana': '70802',
    'Maine': '04330',
    'Maryland': '21401',
    'Massachusetts': '02108',
    'Michigan': '48933',
    'Minnesota': '55102',
    'Mississippi': '39205',
    'Missouri': '65101',
    'Montana': '59601',
    'Nebraska': '68508',
    'Nevada': '89701',
    'New Hampshire': '03301',
    'New Jersey': '08608',
    'New Mexico': '87501',
    'New York': '12207',
    'North Carolina': '27601',
    'North Dakota': '58501',
    'Ohio': '43215',
    'Oklahoma': '73102',
    'Oregon': '97301',
    'Pennsylvania': '17101',
    'Rhode Island': '02903',
    'South Carolina': '29217',
    'South Dakota': '57501',
    'Tennessee': '37219',
    'Texas': '78701',
    'Utah': '84111',
    'Vermont': '05602',
    'Virginia': '23219',
    'Washington': '98501',
    'West Virginia': '25301',
    'Wisconsin': '53703',
    'Wyoming': '82001'
};

const StateAvailabilityPanel = ({ stateData }) => {
    if (!stateData || stateData.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No state data available
                </div>
            </div>
        );
    }

    // Filter only available states
    const safeStateData = Array.isArray(stateData) ? stateData : [];

    if (safeStateData.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No state data available
                </div>
            </div>
        );
    }
    
    // Sort states alphabetically
    const availableStates = safeStateData.filter(state => state && state.available);
    availableStates.sort((a, b) => a.stateName.localeCompare(b.stateName));

    if (availableStates.length === 0) {
        return (
            <div className={styles.panelContainer}>
                <h4 className={styles.panelHeading}>Available Store Locations</h4>
                <div className={styles.noDataMessage}>
                    No stores currently have this item in stock
                </div>
            </div>
        );
    }

    return (
        <div className={styles.panelContainer}>
            <h4 className={styles.panelHeading}>Available Store Locations</h4>
            
            <div className={styles.statesContainer}>
                <div className={styles.headerRow}>
                    <div className={styles.cell}>State</div>
                    <div className={styles.cell}>Zip Code</div>
                </div>
                
                {availableStates.map((state) => (
                    <div 
                        key={state.stateCode} 
                        className={styles.stateRow}
                    >
                        <div className={styles.cell}>{state.stateName}</div>
                        <div className={styles.cell}>{stateZipCodes[state.stateName]}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StateAvailabilityPanel;